import type { DepthLevel } from '@/types/engineer'
import { cn } from '@/lib/utils'

export const DEPTH_LEVELS = ['Exposure', 'Working', 'Production', 'Expert'] as const

interface DepthLevelMeterProps {
  level: DepthLevel
  className?: string
}

export function DepthLevelMeter({ level, className }: DepthLevelMeterProps) {
  const activeIndex = DEPTH_LEVELS.indexOf(level)
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <div className="flex gap-[3px]">
        {DEPTH_LEVELS.map((step, stepIndex) => (
          <span
            key={step}
            className={cn(
              'h-[7px] w-[18px] rounded-[3px]',
              stepIndex <= activeIndex ? 'bg-primary' : 'bg-border',
            )}
          />
        ))}
      </div>
      <span className="font-mono text-[11px] uppercase tracking-[0.08em] text-foreground">
        {level}
      </span>
    </div>
  )
}
